import industriesData from "./industriesData";
import "./services-industries.css";
import {
  FaBuilding,
  FaShoppingBag,
  FaHospital,
  FaGraduationCap,
  FaMoneyBillWave,
  FaRocket,
} from "react-icons/fa";


const ServicesIndustries = () => {
  return (
    <section className="services-industries">
      <div className="services-industries__container">
        {/* HEADER */}
        <div className="services-industries__header section-header">
          <span className="services-industries__badge">
            Industries We Serve
          </span>

          <h2 className="services-industries__title">
            Building Solutions Across <span>Multiple Industries</span>
          </h2>

          <p className="services-industries__subtitle">
            We partner with businesses across industries to deliver secure,
            scalable, and future-ready digital solutions.
          </p>
        </div>

        {/* GRID */}
        <div className="services-industries__grid">
          {industriesData.map((industry) => (
            <div className="services-industries__card" key={industry.id}>
              <div className="services-industries__icon">{industry.icon}</div>
              <h3>{industry.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesIndustries;
